import { useDispatch } from 'react-redux';
import { useEffect, useMemo } from 'react';
import { throttle } from 'lodash';
import { DraggableCore } from 'react-draggable';
import * as appActions from '../actions';

const MIN_WIDTH = 200;
const MAX_WIDTH = 360;
const applyBounds = (width: number) => Math.min(Math.max(width, MIN_WIDTH), MAX_WIDTH);

export const SidebarDragHandler = () => {
  const dispatch = useDispatch();

  // В процессе перетаскивания нужен троттлинг, чтобы перерисовка сайдбара и ассетов не тормозила.
  const setWidthThrottled = useMemo(
    () => throttle((x) => dispatch(appActions.sidebarWidthChanged({ sidebarWidth: x })), 100),
    [dispatch],
  );
  useEffect(() => {
    return () => {
      setWidthThrottled.cancel();
    };
  }, [setWidthThrottled]);

  return (
    <DraggableCore
      onStart={() => {
        dispatch(appActions.setSidebarDragging({ sidebarDragging: true }));
      }}
      onDrag={(e, data) => {
        const newWidth = applyBounds(data.x);
        setWidthThrottled(newWidth);
      }}
      onStop={(e, data) => {
        setWidthThrottled.cancel();
        const newWidth = applyBounds(data.x);
        dispatch(appActions.sidebarWidthChanged({ sidebarWidth: newWidth }));
        dispatch(appActions.setSidebarDragging({ sidebarDragging: false }));
      }}
    >
      <div className="al-app-sidebar-drag-handler" />
    </DraggableCore>
  );
};
